<template>
  <div class="login-container">
    <!-- Geri Butonu -->
    <button class="back-button" @click="goBack">
      <svg class="back-icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
      </svg>
      Ana Sayfa
    </button>
    
    <div class="login-card">
      <div class="login-header">
        <h1>Birebir Randevu Sistemi</h1>
        <p class="login-subtitle">Lütfen hesabınıza giriş yapın</p>
      </div>
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username">Kullanıcı Adı</label>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input
              id="username"
              v-model="formData.username"
              type="text"
              required
              placeholder="Kullanıcı adınızı girin"
            />
          </div>
        </div>

        <div class="form-group">
          <label for="password">Şifre</label>
          <div class="input-wrapper password-input-container">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input
              id="password"
              v-model="formData.password"
              :type="showPassword ? 'text' : 'password'"
              required
              placeholder="Şifrenizi girin"
            />
            <button
              type="button"
              class="password-toggle-btn"
              @click="togglePassword"
              :title="showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'"
              :class="{ 'active': showPassword }"
            >
              <svg v-if="showPassword" class="eye-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg v-else class="eye-off-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
        <button type="submit" :disabled="isLoading" class="login-btn">
          {{ isLoading ? 'Giriş yapılıyor...' : 'Giriş Yap' }}
        </button>
      </form>
    </div>

    <AppErrorModal :message="errorPopup" @close="errorPopup = ''" />
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import AppErrorModal from '@/components/AppErrorModal.vue'

export default {
  name: 'LoginView',
  components: { AppErrorModal },
  setup() {
    const router = useRouter()
    const store = useStore()
    const isLoading = ref(false)
    const showPassword = ref(false)
    const errorPopup = ref('')
    const formData = ref({
      username: '',
      password: ''
    })

    const togglePassword = () => {
      showPassword.value = !showPassword.value
    }
    
    const goBack = () => {
      router.push('/') // Ana sayfaya dön
    }

        

    const handleLogin = async () => {
      if (!formData.value.username || !formData.value.password) {
        errorPopup.value = 'Lütfen tüm alanları doldurun.'
        return
      }

      isLoading.value = true

      try {
        // Backend'e giriş isteği gönder - store'dan API_URL kullan
        const apiUrl = 'https://api.modernkurs.com'
        console.log('🔗 Login isteği gönderiliyor:', `${apiUrl}/api/login`)
        
        const response = await fetch(`${apiUrl}/api/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache'
          },
          body: JSON.stringify(formData.value),
          cache: 'no-store'
        })

        console.log('📡 Response status:', response.status, response.statusText)

        if (response.ok) {
          const data = await response.json()
          console.log('✅ Login başarılı:', data)
  
          // Backend response yapısı: { success, token, user: { id, username, role, ad, soyad } }
          const userInfo = {
            id: data.user.id,
            username: data.user.username,
            ad: data.user.ad,
            soyad: data.user.soyad,
            role: data.user.role
          }
          store.commit('setCurrentUser', userInfo)
          
          // localStorage'a user bilgisini kaydet
          localStorage.setItem('user', JSON.stringify(userInfo))
          
          // Token'ı localStorage'a kaydet
          if (data.token) {
            localStorage.setItem('token', data.token)
            console.log('🔑 Token kaydedildi')
            
            // Login başarılı olduğunda logout bayrağını temizle
            window.isLoggedOut = false
            console.log('🔄 Logout bayrağı temizlendi')
          } else {
            console.warn('⚠️ Backend\'den token gelmedi')
          }
          
          // Role göre yönlendirme (backend'den gelen Türkçe role'ü kullan)
          router.push(`/panel/${data.user.role}`)
        } else {
          console.error('❌ Login başarısız:', response.status, response.statusText)
          let errorMessage = 'Giriş başarısız'
          
          try {
            const errorData = await response.json()
            errorMessage = errorData.error || errorMessage
            console.error('❌ Error data:', errorData)
          } catch (parseError) {
            console.error('❌ Response parse hatası:', parseError)
            errorMessage = `Sunucu hatası (${response.status}): ${response.statusText}`
          }
          
          errorPopup.value = errorMessage
        }
      } catch (error) {
        console.error('❌ Giriş hatası:', error)
        
        let errorMessage = 'Giriş yapılırken bir hata oluştu'
        
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
          errorMessage = 'Sunucuya bağlanılamıyor. Lütfen internet bağlantınızı kontrol edin.'
        } else if (error.name === 'AbortError') {
          errorMessage = 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.'
        } else {
          errorMessage = `Hata: ${error.message}`
        }
        
        errorPopup.value = errorMessage
      } finally {
        console.log('🔄 Loading durumu temizleniyor')
        isLoading.value = false
      }
    }

    return {
      formData,
      isLoading,
      showPassword,
      errorPopup,
      togglePassword,
      handleLogin,
      goBack
    }
  }
}
</script>

<style scoped>
/*
  Login ekran teması: "Academic Precision" (stitch tasarımı).
  Primary Academic Navy (#000a21 / #12213d) — arka plan gradient.
  Secondary Vibrant Cyan (#006687) — buton, focus, ikon vurguları.
*/
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #000a21;
  background-image:
    radial-gradient(circle at 20% 30%, #12213d 0%, transparent 55%),
    radial-gradient(circle at 80% 70%, #001e2b 0%, transparent 55%);
  position: relative;
  padding: 1.5rem;
}

/* Geri Butonu */
.back-button {
  position: absolute;
  top: 2rem;
  left: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(248, 249, 255, 0.95);
  color: #0b1c30;
  border: 1px solid #c5c6ce;
  padding: 0.65rem 1.1rem;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(11, 28, 48, 0.15);
}

.back-button:hover {
  background: #ffffff;
  border-color: #006687;
  color: #006687;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 102, 135, 0.2);
}

.back-icon {
  width: 18px;
  height: 18px;
  transition: transform 0.2s ease;
}

.back-button:hover .back-icon {
  transform: translateX(-3px);
}

.login-card {
  background: #ffffff;
  padding: 2.5rem 2rem;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(18, 33, 61, 0.35);
  width: 100%;
  max-width: 440px;
  position: relative;
  z-index: 1;
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-card h1 {
  color: #0b1c30;
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  letter-spacing: -0.01em;
}

.login-subtitle {
  color: #45474d;
  font-size: 0.95rem;
  margin: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 500;
  color: #45474d;
  font-size: 0.875rem;
  letter-spacing: 0.01em;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 0.85rem;
  width: 20px;
  height: 20px;
  color: #75777e;
  pointer-events: none;
  transition: color 0.2s ease;
}

.form-group input {
  width: 100%;
  padding: 0.85rem 0.85rem 0.85rem 2.65rem;
  border: 1px solid #c5c6ce;
  border-radius: 10px;
  font-size: 0.95rem;
  color: #0b1c30;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-group input::placeholder {
  color: #a0a3ab;
}

.form-group input:hover {
  border-color: #75777e;
}

.form-group input:focus {
  outline: none;
  border-color: #006687;
  box-shadow: 0 0 0 3px rgba(0, 102, 135, 0.15);
}

.form-group input:focus + .password-toggle-btn,
.input-wrapper:focus-within .input-icon {
  color: #006687;
}

/* Şifre alanının sağında toggle butonu için ekstra padding */
.password-input-container input {
  padding-right: 3rem;
}

.password-toggle-btn {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #75777e;
}

.password-toggle-btn:hover {
  background: rgba(0, 102, 135, 0.08);
  color: #006687;
}

.password-toggle-btn:active {
  transform: translateY(-50%) scale(0.95);
}

.password-toggle-btn.active {
  color: #006687;
}

.eye-icon,
.eye-off-icon {
  width: 20px;
  height: 20px;
  color: currentColor;
  transition: color 0.2s ease;
}

.login-btn {
  background: #006687;
  color: #ffffff;
  padding: 0.95rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 102, 135, 0.25);
  margin-top: 0.5rem;
}

.login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.18), transparent);
  transition: left 0.5s;
}

.login-btn:hover:not(:disabled) {
  background: #005774;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0, 102, 135, 0.35);
}

.login-btn:hover:not(:disabled)::before {
  left: 100%;
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(0, 102, 135, 0.25);
}

.login-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .back-button {
    top: 1rem;
    left: 1rem;
    padding: 0.55rem 0.95rem;
    font-size: 0.9rem;
  }

  .back-icon {
    width: 16px;
    height: 16px;
  }

  .login-card {
    margin: 1rem;
    padding: 2rem 1.5rem;
  }

  .login-card h1 {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .back-button {
    top: 0.8rem;
    left: 0.8rem;
    padding: 0.5rem 0.8rem;
    font-size: 0.85rem;
  }

  .login-card {
    margin: 0.5rem;
    padding: 1.75rem 1.25rem;
  }

  .login-card h1 {
    font-size: 1.4rem;
  }

  .login-subtitle {
    font-size: 0.875rem;
  }
}
</style>
# Build trigger
# Build trigger - HTTPS API URL
